export const environment = {
  production: false,
  version: '0.1.0',
  appName: 'Project Brendan UI',

  api: {
    baseUrl: 'http://127.0.0.1:4201/'
  },

  auth: {
    issuer: 'project-brendan',
    clientId: '',
    redirectUri: ''
  }
};
